<template>
  <div v-if="regions.length !== 1" class="input input_s_m" style="margin-right: 10px;">
    <select class="input__field" v-model="value">
      <option :value="undefined">Все регионы</option>
      <option
        v-for="region in regions"
        :key="region.id"
        :value="region.id"
      >{{ region.name }}</option>
    </select>
  </div>
</template>

<script lang="ts" setup>
import store from '@/store'
import { computed } from 'vue'

const value = computed({
  get: () => store.state.regionId,
  set: (value: number) => store.setCurrentRegion(value)
})

const regions = computed(() => store.state.regions)

</script>
